import { useEffect, useState } from 'react';
import Popup from '../common/Popup';
import classes from './GacTreatware.module.css'
import CloseIcon from '../../icons/closeicon';
import WarningIcon from '../../icons/warningicon';

const GacTreatware = ({pop, closeModalHandler, data}) =>  {

    // const [redirectTimeLeft, setRedirectTimeLeft] = useState(5)

    // useEffect(() => {
    //     console.log('data:::: ', data)
    //     // let timeout = setTimeout(() => {
    //     //     console.log('aaaaaaaaaaaaaa')
    //     // }, 3000)

    //     var timeleft = 5;
    //     var downloadTimer = setInterval(function(){
    //       if(timeleft <= 0){
    //         clearInterval(downloadTimer);
    //         // closeModalHandler()
    //         // window.location = `https://order.greatamericancookies.com/menu/${data.slug}`
    //         console.log('redirect now!!!!!!!')
    //       } else {
    //         setRedirectTimeLeft(timeleft)
    //       }
    //       timeleft -= 1;
    //     }, 1000);

    //     return () => {
    //         // clearTimeout(timeout);
    //         clearInterval(downloadTimer)
    //     };

    // }, [])

    // console.log('pop:::: ', pop)
    return <Popup transition={pop}>
        <button className={classes.close_modal} onClick={closeModalHandler}>
            <CloseIcon />
            <span className='sr-only'>close modal</span>
        </button>
        <p className={classes.header}>
            <WarningIcon />
            {/* <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg> */}
            <strong>Heads up! </strong>
            This location does not participate in our new custom ordering experience. You will be redirected to the standard ordering site.
        </p>
        {/* <p className={classes.redirect_text}>Redirect in <span>{redirectTimeLeft}</span></p> */}
        <div className={classes.footer_controls}>
            <button className='btn btn-border' onClick={closeModalHandler}>
                Find Another Location
            </button>
            <a href={`https://order.greatamericancookies.com/menu/${data.slug}`} className='btn'>Continue</a>
        </div>
    </Popup>
}

export default GacTreatware